module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/edit-text-6cc401a363a1ca10936bc15e0c3cd4b1.svg";